// extracted by mini-css-extract-plugin
module.exports = {"link":"jgp-1NmY_","mini":"jgp-EO6jj","image":"jgp-1mHyn"};